module.exports = __webpack_public_path__ + "static/media/encontra-foto1.9cfa67bd.jpg";